import * as React from 'react';
import {DropZoneProps, DropZoneState} from '../../types/components';
import AssetsManager from '../../utils/AssetsManager';
// tslint:disable-next-line: import-name
import Dropzone from 'react-dropzone';
import * as MimeTypeConstants from '../../constants/MimeTypeConstants';
import {COMMON} from '../../constants/LabelConstants';

class DropZone extends React.Component<DropZoneProps, DropZoneState> {

    constructor(props) {
        super(props);
        this.state = {
            isDragging: false
        };
    }

    static defaultProps = {
        required: false,
        customClass: '',
        hasError: false,
        labelError: ''
    };

    onDragLeave = evt => this.setState({...this.state, isDragging: false});

    onDragOver = (evt) => {
        evt.preventDefault();
        if (!this.state.isDragging) this.setState({...this.state, isDragging: true});
    }

    validate = (error: boolean) => error ? COMMON.FILE_TYPE_NOT_ALLOWED : null;
    validateSize = (error: boolean) => error ? COMMON.FILE_SIZE_NOT_ALLOWED : null;

    onDrop = (accepted, rejected) => {
        const {maxSize, required, onDrop} = this.props;
        if (this.state.isDragging) this.setState({...this.state, isDragging: false});
        const error = this.validateSize(rejected.filter(item => item.file.size > maxSize).length > 0)
            || this.validate(required && (rejected.length > 0 || accepted.length === 0))
            || this.validate(rejected.length > 0);
        onDrop(accepted, error);
    }

    render() {
        const {isDragging} = this.state;
        const {id, label, labelError, customClass, labelButton, hasError, maxSize, multiple, mimeTypesAccepted} = this.props;
        let dropSection = !!customClass ? customClass :
            'drag-drop-section d-flex flex-row justify-content-center align-items-center';
        if (isDragging) dropSection = `${dropSection} dragging`;
        const invalidClass = hasError && labelError && 'is-invalid';
        const mimeTypes = mimeTypesAccepted === undefined ? MimeTypeConstants.DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES : mimeTypesAccepted;

        return (
            <React.Fragment>
                <Dropzone
                    multiple={multiple === undefined ? true : multiple}
                    maxSize={maxSize}
                    accept={mimeTypes}
                    onDragOver={this.onDragOver}
                    onDragLeave={this.onDragLeave}
                    onDrop={this.onDrop}>
                    {({ getRootProps, getInputProps }) => (
                        <div className={dropSection} {...getRootProps()}>
                        <div className="col">
                            <input {...getInputProps()} />
                            <img src={AssetsManager('/assets/images/admin/img-file-normal-icon.svg')}
                                alt="Attention" />
                            <p className="disclaimer-text disclaimer-text mt-4 mb-0">
                                {label}
                            </p>
                            <p className="drag-selected-label mt-3">
                                {labelButton}
                            </p>
                        </div>
                        </div>
                    )}
                </Dropzone>
                {hasError && labelError &&
                <strong className={`form-text ${invalidClass}`}>
                    {labelError}
                </strong>}
            </React.Fragment>
        );
    }
}

export default DropZone;
